// extracted by mini-css-extract-plugin
module.exports = {"editCardForm":"styles_editCardForm__2Odt8","checkbox":"styles_checkbox__5oN6t","buttons":"styles_buttons__wCkYN","spinner":"styles_spinner__1Huk7"};